if (!customElements.get('lyss-pairing')) {
  customElements.define('lyss-pairing', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.querySelector('[data-open]')?.addEventListener('click', () => this.open(), options);
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.querySelector('select')?.addEventListener('change', event => {
        this.querySelector('[data-pairing-price]').textContent = event.target.selectedOptions[0]?.dataset.price || '';
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      window.addEventListener('pageshow', event => {
        if (event.persisted) window.lyssPairingOpenedThisVisit = false;
        this.schedule();
      }, options);
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || window.lyssPairingOpenedThisVisit || window.Shopify?.designMode || document.visibilityState !== 'visible') return;
      this.timer = setTimeout(() => {
        if (!this.isConnected || window.lyssPairingOpenedThisVisit || document.visibilityState !== 'visible') return;
        if (document.querySelector('dialog[open]')) {
          this.schedule();
          return;
        }
        this.open();
      }, 700);
    }
    open() {
      if (!this.dialog || this.dialog.open || typeof this.dialog.showModal !== 'function') return;
      this.dialog.showModal();
      window.lyssPairingOpenedThisVisit = true;
      clearTimeout(this.timer);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.events?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
